import Vue from 'vue'
let _ = require('lodash')

Vue.filter('capitalize', function(value) {
    if (value) {
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    }
})

Vue.filter('firstLetterCapital', function(value) {
    return value.charAt(0).toUpperCase()
})

Vue.filter('onlyNumbers', function(value) {
    if (value) {
        return value.replace(/\D+/g, '');
    }
})

Vue.filter('pluralize', function(count, word) {
    return count > 1 ? `${word}s` : word;
})

Vue.filter('implode', function (value, piece, key) {
    piece = piece ? piece : ', ';
    if(_.isUndefined(key)) {
        return value.join(piece);
    }
    return _.map(value, key).join(piece);
});

Vue.filter('pluck', function (objects, key) {
    return objects.map(function(object) {
        return object[key];
    });
});

Vue.filter('formatNumberToThousands', function (number, digits = 2) {
    if(number >= 1000000) {
        if(number % 1000000 === 0 ) {
            return (number / 1000000).toFixed() + 'M'
        } else {
            return (number / 1000000).toFixed(digits) + 'M'
        }
    } else if(number >= 1000) {
        if(number % 1000 === 0 ) {
            return (number / 1000).toFixed() + 'k'
        } else {
            return (number / 1000).toFixed(digits) + 'k'
        }
    } else {
        if(number % 1 === 0) {
            return number.toFixed()
        } else {
            return number.toFixed(digits)
        }

    }
})